import { createClient } from 'contentful';

// Get environment variables with fallbacks
const spaceId = process.env.REACT_APP_CONTENTFUL_SPACE_ID || 'zvxjy2jhrdxf';
const accessToken = process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN || 'J83KjiWCput-MFi21kzxS2VRu7GSrWuTXuP6fzuexf0';
const environment = process.env.REACT_APP_CONTENTFUL_ENVIRONMENT || 'master';

// Debug log environment variables (remove in production)
console.log('Contentful Config:', {
  spaceId: spaceId ? 'SET' : 'MISSING',
  accessToken: accessToken ? 'SET' : 'MISSING',
  environment
});

// Validate environment variables
if (!spaceId) {
  console.error('REACT_APP_CONTENTFUL_SPACE_ID environment variable is required');
}

if (!accessToken) {
  console.error('REACT_APP_CONTENTFUL_ACCESS_TOKEN environment variable is required');
}

// Contentful client configuration
const client = createClient({
  space: spaceId,
  accessToken: accessToken,
  environment: environment,
  host: 'cdn.contentful.com'
});

export default client;